<template>
    <v-text-field
            :label="label"
            :rules="rules"
            outlined
            placeholder="YYYY-MM-DD"
            type="text"
            v-mask="mask"
            v-model="innerValue"
    ></v-text-field>
</template>

<script>

    import {mask} from 'vue-the-mask'

    export default {
        props: {
            rules: {
                type: [Object, Array, String],
                default: () => {
                    return [value => {
                        const pattern = /^(?:19|20|21)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))$/
                        return pattern.test(value) || 'Invalid Date Format'
                    }];
                },
            },
            label: {
                type: String,
                value: ''
            },
            prepand_icon: {
                type: String,
                value: ''
            },
            value: {
                type: null
            }
        },
        name: "FormattedDate",
        directives: {
            mask,
        },
        data() {
            return {
                innerValue: null,
                mask: '####-##-##',
            }
        },
        watch: {
            innerValue(new_value) {
                this.$emit('input', new_value)
            },
            value(new_value) {
                this.innerValue = new_value
            }
        },
        created() {
            if (this.value) {
                this.innerValue = this.value;
            }
        },
        methods: {}
    }
</script>
